import ListViewModel from "@vm/List/ListViewModel";
import AllocationItem from "@model/AllocationItem";
import { inject, injectable } from "inversify";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class AllocationItemListVM extends ListViewModel<AllocationItem, Repository<AllocationItem>> {
  constructor(@inject(TYPES.AllocationItemRepository) repository: Repository<AllocationItem>) {
    super(repository);
  }
}
